import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["activeView"];
import * as React from 'react';
import { RootContext } from './context';
import { EActiveView } from '../../types/view';
import { UsernameAuthViewContainer } from '../UsernameAuthViewContainer';
import { PhoneAuthViewContainer } from '../PhoneAuthViewContainer';
import { PhoneAuthValidateSmsViewContainer } from '../PhoneAuthValidateSmsViewContainer';
import { PhoneAuthValidateCallViewContainer } from '../PhoneAuthValidateCallViewContainer';
import { RestoreViewContainer } from '../RestoreViewContainer';
import { EmailSentViewContainer } from '../EmailSentViewContainer';
import { TwoFactorAttemptsExhaustedViewContainer } from '../TwoFactorAttemptsExhaustedViewContainer';
import { TwoFactorWithEmailViewContainer } from '../TwoFactorWithEmailViewContainer';
import { ConfirmPhoneViewContainer } from '../ConfirmPhoneViewContainer';
import { TwoFactorViewContainer } from '../TwoFactorVewContainer';
import { SocialCreateViewContainer } from '../SocialCreateViewContainer';
import { SocialMergeViewContainer } from '../SocialMergeViewContainer';
import { AccountSelectView } from '../AccountSelectView';
import { ConfirmAccountViewContainer } from '../ConfirmAccountView/connect';
import { TokenExpiredErrorViewContainer } from '../TokenExpiredErrorView/connect';
import { AccountSelectErrorViewContainer } from '../AccountSelectErrorView/connect';
import { PhoneCallOnboardingContainer } from '../PhoneCallOnboardingContainer/connect';
import { AgreementViewContainer } from '../AgreementViewContainer';
export function RootContainer(_ref) {
  var activeView = _ref.activeView,
      props = _objectWithoutProperties(_ref, _excluded);

  var ViewContainer = React.useMemo(function () {
    switch (activeView) {
      case EActiveView.AuthenticationRegistration:
        return UsernameAuthViewContainer;

      case EActiveView.Agreement:
        return AgreementViewContainer;

      case EActiveView.PhoneAuth:
        return PhoneAuthViewContainer;

      case EActiveView.PhoneCallOnboarding:
        return PhoneCallOnboardingContainer;

      case EActiveView.PhoneAuthValidateSms:
        return PhoneAuthValidateSmsViewContainer;

      case EActiveView.PhoneAuthValidateCall:
        return PhoneAuthValidateCallViewContainer;

      case EActiveView.AccountSelect:
        return AccountSelectView;

      case EActiveView.ConfirmSelectedAccount:
        return ConfirmAccountViewContainer;

      case EActiveView.TokenExpiredError:
        return TokenExpiredErrorViewContainer;

      case EActiveView.AccountSelectError:
        return AccountSelectErrorViewContainer;

      case EActiveView.Restore:
        return RestoreViewContainer;

      case EActiveView.TwoFactor:
        return TwoFactorViewContainer;

      case EActiveView.TwoFactorAttemptsExhausted:
        return TwoFactorAttemptsExhaustedViewContainer;

      case EActiveView.TwoFactorWithEmail:
        return TwoFactorWithEmailViewContainer;

      case EActiveView.ConfirmPhone:
        return ConfirmPhoneViewContainer;

      case EActiveView.EmailSent:
        return EmailSentViewContainer;

      case EActiveView.SocialCreate:
        return SocialCreateViewContainer;

      case EActiveView.SocialMerge:
        return SocialMergeViewContainer;

      default:
        return null;
    }
  }, [activeView]);
  return /*#__PURE__*/React.createElement(RootContext.Provider, {
    value: props
  }, ViewContainer && /*#__PURE__*/React.createElement(ViewContainer, null));
}